import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { PageContainer } from '../components/layout/PageContainer';
import { Logo } from '../components/common/Logo';

export function PrivacyPolicyPage() {
  return (
    <PageContainer className="px-4 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-2xl mx-auto"
      >
        <div className="text-center mb-8">
          <Logo size="lg" className="mb-2" />
        </div>

        <div className="glass-card rounded-3xl p-6 sm:p-8">
          <Link to="/login" className="inline-flex items-center gap-1 text-turquoise text-sm mb-6 hover:underline">
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Link>

          <h1 className="text-2xl font-bold text-white mb-6">Politica de Privacidade</h1>

          <div className="space-y-6 text-white/70 text-sm leading-relaxed">
            <p>Ultima atualizacao: 12 de marco de 2026</p>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">1. Dados que coletamos</h2>
              <p>Ao utilizar o BT Vision, coletamos:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li><strong className="text-white/90">Dados da conta:</strong> endereco de email e informacoes de autenticacao (via Google ou magic link).</li>
                <li><strong className="text-white/90">Perfil LetzPlay:</strong> nome de usuario LetzPlay que voce conecta voluntariamente.</li>
                <li><strong className="text-white/90">Dados de torneios e partidas:</strong> informacoes publicas de torneios e partidas coletadas da plataforma LetzPlay vinculadas ao seu perfil.</li>
                <li><strong className="text-white/90">Dados de uso:</strong> interacoes com o aplicativo para melhorar a experiencia.</li>
                <li><strong className="text-white/90">Dados de pagamento:</strong> processados diretamente pelo Stripe. Nao armazenamos dados de cartao de credito.</li>
                <li><strong className="text-white/90">CPF e data de nascimento:</strong> coletados apenas quando voce entra em um ranking com inscricao paga, pois sao exigidos pelo processador de pagamentos (Asaas) para gerar a cobranca PIX. O CPF e compartilhado somente com o Asaas e com o organizador do ranking (titular da conta Asaas que recebe o pagamento).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">2. Como usamos seus dados</h2>
              <ul className="list-disc list-inside space-y-1">
                <li>Gerar estatisticas e insights sobre seu desempenho no beach tennis.</li>
                <li>Fornecer funcionalidades do dashboard como ranking de duplas, historico de torneios e oponentes.</li>
                <li>Processar assinaturas e pagamentos.</li>
                <li>Enviar comunicacoes relacionadas ao servico (ex: confirmacao de conta, atualizacoes importantes).</li>
                <li>Melhorar e desenvolver novas funcionalidades.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">3. Compartilhamento de dados</h2>
              <p>Nao vendemos seus dados pessoais. Compartilhamos dados apenas com:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li><strong className="text-white/90">Supabase:</strong> armazenamento de dados e autenticacao.</li>
                <li><strong className="text-white/90">Stripe:</strong> processamento de pagamentos.</li>
                <li><strong className="text-white/90">Asaas:</strong> processamento de cobrancas PIX de rankings com inscricao paga (via a conta Asaas do organizador do ranking).</li>
                <li><strong className="text-white/90">Sentry:</strong> monitoramento de erros para manter a qualidade do servico.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">4. Grupos e dados publicos</h2>
              <p>Ao participar de grupos no BT Vision, seu nome de usuario LetzPlay e estatisticas de desempenho serao visiveis para outros membros do grupo. Voce pode sair de um grupo a qualquer momento.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">5. Retencao de dados</h2>
              <p>Mantemos seus dados enquanto sua conta estiver ativa. Voce pode solicitar a exclusao da sua conta e dados a qualquer momento atraves da pagina de configuracoes ou entrando em contato conosco.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">6. Seus direitos</h2>
              <p>Voce tem direito a:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Acessar seus dados pessoais.</li>
                <li>Solicitar correcao de dados incorretos.</li>
                <li>Solicitar exclusao da sua conta e dados.</li>
                <li>Revogar consentimento a qualquer momento.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">7. Seguranca</h2>
              <p>Utilizamos medidas tecnicas e organizacionais para proteger seus dados, incluindo criptografia em transito (HTTPS), autenticacao segura e acesso restrito a dados.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">8. Contato</h2>
              <p>Para duvidas sobre privacidade, entre em contato pelo email: <a href="mailto:contato@retrospectivabeach.online" className="text-turquoise hover:underline">contato@retrospectivabeach.online</a></p>
            </section>
          </div>
        </div>

        <p className="mt-8 text-center text-sm text-white/30">
          &copy; 2026 BT Vision &bull; btvision.app
        </p>
      </motion.div>
    </PageContainer>
  );
}
